import axios from 'axios';
import { API_URL } from '../../../configs/apiUrls'
export const APPLICATIONS_REQUEST = 'APPLICATIONS_REQUEST'
export const APPLICATIONS_SUCCESS = 'APPLICATIONS_SUCCESS'
export const APPLICATIONS_VALIDATION_ERROR = 'APPLICATIONS_VALIDATION_ERROR'

export const HIDE_APPLICATIONS_FEILD_VALIDATION_ERROR = "HIDE_APPLICATIONS_FEILD_VALIDATION_ERROR"
export const REDIRECT_TO_APPLICATIONS_LIST = 'REDIRECT_TO_APPLICATIONS_LIST'
export const APPLICATIONS_GET_SUCCESS = 'APPLICATIONS_GET_SUCCESS'
export const APPLICATIONS_DROPDOWN_LIST_SUCCESS = 'APPLICATIONS_DROPDOWN_LIST_SUCCESS'
export const APPLICATIONS_SERVER_SUCCESS = 'APPLICATIONS_SERVER_SUCCESS'
export const USERS_APPLICATIONS_LIST_SUCCESS = 'USERS_APPLICATIONS_LIST_SUCCESS'
const SHOW_LOADER = 'SHOW_LOADER';
const HIDE_LOADER = 'HIDE_LOADER';
const SHOW_SNACKBAR = 'SHOW_SNACKBAR';
const HIDE_SNACKBAR = 'HIDE_SNACKBAR';

const showCommonLoader = (label = '') => ({
  type: SHOW_LOADER,
  common_loder_label: label
})
const hideCommonLoader = () => ({
  type: HIDE_LOADER,
})

const applicationsRequest = () => ({
  type: APPLICATIONS_REQUEST,
})

export const applicationsServerListSuccess = () => ({
  type: APPLICATIONS_SERVER_SUCCESS,
})

const applicationsListSuccess = applicationsList => ({
  type: APPLICATIONS_SUCCESS,
  applicationsList: applicationsList,
})

const getApplicationsSuccess = (response, action) => ({
  type: APPLICATIONS_GET_SUCCESS, 
  record: response,
  actionType: action
})

const applicationsFailure = notification => ({
  type: SHOW_SNACKBAR,
  snackbar_notification: notification,
  snackbar_notification_type: 'general_error'
})
const validationError = notification => ({
  type: APPLICATIONS_VALIDATION_ERROR,
  validation_error: notification,
})
const tokenError = notification => ({
  type: SHOW_SNACKBAR,
  snackbar_notification: notification,
  snackbar_notification_type: 'token_expire'
})

const applicationsAddUpadteSuccess = (message, action, dispatch) => {
  dispatch(applicationsSuccessNotification(message))
  dispatch(redirectToApplicationsList())
}

export const redirectToApplicationsList = () => ({
  type: REDIRECT_TO_APPLICATIONS_LIST,
})

const getUsersSuccess = (response, action) => ({
  type: APPLICATIONS_GET_SUCCESS,
  record: response,
  actionType: action
})

const applicationsSuccessNotification = message => ({
  type: SHOW_SNACKBAR,
  snackbar_notification: message,
  snackbar_notification_type: 'success'
})


export const hideApplicationsValidationError = (feild_key) => ({
  type: HIDE_APPLICATIONS_FEILD_VALIDATION_ERROR,
  feild_key: feild_key
})

/*
* applications dropdown list fetch methods
*/
const applicationsDropdownListSuccess = applicationsDropdownList => ({
  type: APPLICATIONS_DROPDOWN_LIST_SUCCESS,
  applicationsDropdownList: applicationsDropdownList,
});

const getUserApplicationsListSuccess = usersApplicationsList => ({
  type: USERS_APPLICATIONS_LIST_SUCCESS,
  usersApplicationsList: usersApplicationsList,
});

const applicationsAddUpdateSuccess = (message, action, dispatch) => {
  dispatch(applicationsSuccessNotification(message))
  dispatch(redirectToApplicationsList())
}




export const addApplications = (data) => {
  var token = localStorage.getItem("token")
  return dispatch => {
    dispatch(applicationsRequest())
    dispatch(showCommonLoader())
    return axios(API_URL + "app/create", {
      method: "POST",
      headers: {
        Accept: 'application/json',
        'Authorization': 'Bearer ' + token
      },
      data: data,
    })
      .then((response) => {
        dispatch(hideCommonLoader())
        applicationsAddUpdateSuccess('Application Added Successfully', 'create', dispatch)
      }, (error) => {
        dispatch(hideCommonLoader())
        handleErrorResponse(error, dispatch)
      });

  }
}


export const updateApplications = (data) => {
  var token = localStorage.getItem("token")
  return dispatch => {
    dispatch(applicationsRequest())
    dispatch(showCommonLoader())
    return axios(API_URL + "app/update/" + data.get('id'), {
      method: "POST",
      headers: {
        Accept: 'application/json',
        'Authorization': 'Bearer  ' + token
      },
      data: data
    })
      .then((response) => {
        dispatch(hideCommonLoader())
        applicationsAddUpdateSuccess('Application Updated Successfully', 'update', dispatch)
      }, (error) => {
        dispatch(hideCommonLoader())
        handleErrorResponse(error, dispatch)
      });

  }
}

export const getApplicationsById = (id, action) => {
  var token = localStorage.getItem("token")
  return dispatch => {
    dispatch(applicationsRequest())
    dispatch(showCommonLoader())
    return axios(API_URL + "app/getById/" + id, {
      method: "GET",
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'Authorization': 'Bearer  ' + token
      },
    })
      .then((response) => {
        dispatch(hideCommonLoader())
        dispatch(getApplicationsSuccess(response.data, action))
      }, (error) => {
        dispatch(hideCommonLoader())
        handleErrorResponse(error, dispatch)
      });

  }
}

export const deleteApplications = (appId, object_viewed_id) => {
  var token = localStorage.getItem("token")
  return dispatch => {
    dispatch(applicationsRequest())
    dispatch(showCommonLoader())
    return axios(API_URL + "app/delete/" + appId, {
      method: "DELETE",
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'Authorization': 'Bearer ' + token
      },
      data: {
        // object_viewed_id
      }
    })
      .then((response) => {
        dispatch(hideCommonLoader())
        dispatch(applicationsSuccessNotification('Application deleted successfully'))
      }, (error) => {
        dispatch(hideCommonLoader())
        handleErrorResponse(error, dispatch)
      });
  }

}
export const applicationsListFetch = (object_viewed_id = '') => {
  var token = localStorage.getItem("token")
  return dispatch => {
    dispatch(applicationsRequest())
    return axios(API_URL + "app", {
      method: "GET",
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'Authorization': 'Bearer ' + token
      },
      params: { object_viewed_id: object_viewed_id }
    })
      .then((response) => {

        dispatch(applicationsListSuccess(response.data))
      }, (error) => {
        handleErrorResponse(error, dispatch)
      });

  }
}

export const getUserApplicationsListFetch = (object_viewed_id = '') => {
  var token = localStorage.getItem("token")
  return dispatch => {
    dispatch(applicationsRequest())
    return axios(API_URL + "app/getUserApps", {
      method: "POST",
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'Authorization': 'Bearer ' + token
      },
      data: { object_viewed_id: object_viewed_id }
    })
      .then((response) => {

        dispatch(getUserApplicationsListSuccess(response.data))
      }, (error) => {
        handleErrorResponse(error, dispatch)
      });

  }
}

export const grantAccess = (userId, appData) => {
  var token = localStorage.getItem("token");

  return dispatch => {
    dispatch(showCommonLoader());
    dispatch(applicationsRequest());
    return axios(API_URL + "app/grant/" + userId, {
      method: "POST",
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'Authorization': 'Bearer ' + token,
      },
      data: appData, // Sending the appData object
    })
      .then((response) => {
        dispatch(hideCommonLoader());
        dispatch(applicationsSuccessNotification('Access Granted Successfully'))
        //applicationsAddUpadteSuccess('User Added Successfully', 'create', dispatch);
      }, (error) => {
        dispatch(hideCommonLoader());
        handleErrorResponse(error, dispatch);
      });
  }
}


// handling error reponse   
const handleErrorResponse = (error, dispatch) => {
  try {
    if (error.response.status === 422 && error.response.data.error) {
      dispatch(validationError(error.response.data.error))
    }
    else if (error.response.status === 401 && error.response.data.error) {
      dispatch(tokenError(error.response.data.error.toString()))
    }
    else {
      let err = '';
      if (error.response.data.error) {
        err = error.response.data.error.toString()
      }
      else {
        err = error.response.status + ` ` + error.response.statusText
      }
      dispatch(applicationsFailure(err))
    }
  }
  catch (e) {
    dispatch(applicationsFailure('Unable to perform action.Something went wrong'))
  }
}   